import React, { useRef } from 'react';
import { motion, useScroll, useTransform, useReducedMotion } from 'framer-motion';
import { makes, now, site } from '../content';
import { FitText } from './FitText';
import { Reveal, SplitChars } from './Reveal';
import { RollingWord } from './RollingWord';
import { EASE_OUT } from './motion';

export function Hero({ show }: { show: boolean }) {
  const ref = useRef<HTMLElement>(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start start', 'end start'] });
  const nameY = useTransform(scrollYProgress, [0, 1], ['0%', reduce ? '0%' : '38%']);
  const introY = useTransform(scrollYProgress, [0, 1], ['0%', reduce ? '0%' : '-30%']);
  const fade = useTransform(scrollYProgress, [0, 0.6], [1, 0]);

  return (
    <section id="top" ref={ref} className="hero">
      <motion.div className="hero__intro wrap" style={{ y: introY, opacity: fade }}>
        <h2 className="hero__statement">
          <Reveal show={show} delay={0.35}>
            Software engineer,
          </Reveal>
          <Reveal show={show} delay={0.45}>
            founder &amp; polymath.
          </Reveal>
          <Reveal show={show} delay={0.55}>
            <span className="muted">I make</span> <RollingWord words={makes} />
          </Reveal>
        </h2>

        <motion.ul
          className="hero__facts mono"
          initial={{ opacity: 0 }}
          animate={{ opacity: show ? 1 : 0 }}
          transition={{ duration: 1, ease: EASE_OUT, delay: 0.9 }}
        >
          {now.map((item) => (
            <li key={item.name}>
              <span className="muted">{item.label}</span>
              <a
                className="u-link keep-case"
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                data-cursor="Visit"
              >
                {item.name} ↗
              </a>
            </li>
          ))}
          <li>
            <span className="muted">Since</span>
            <span>{site.since}</span>
          </li>
        </motion.ul>
      </motion.div>

      <motion.div className="hero__name-wrap" style={{ y: nameY }}>
        <FitText as="h1" className="hero__name wrap">
          <SplitChars text={site.name} show={show} delay={0.1} stagger={0.05} />
        </FitText>
      </motion.div>
    </section>
  );
}
